export const options = {
  xappid: 'admin',
  password: '123456',
  baseURL: 'https://www.holywiser.com/wxpublic'
}